/**
 * MarketingResponsesLayout — tab shell for the Marketing Responses module.
 *
 * Renders a top tab bar that links Board / Stats / Routing. Each child route
 * renders inside <Outlet/> below the tabs.
 *
 * Sidebar collapses to a single "Marketing Responses" entry → the Board;
 * Stats and Routing move from sidebar indents into tabs here.
 */

import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const BASE_TABS = [
  { to: "/growth/marketing-responses", label: "Board", end: true, permission: "marketing.responses.view" },
  { to: "/growth/marketing-responses/stats", label: "Stats", permission: "marketing.responses.admin" },
  { to: "/growth/marketing-responses/routing", label: "Routing", permission: "marketing.responses.admin" },
];

export default function MarketingResponsesLayout() {
  const { hasPermission } = useAuth();
  const tabs = BASE_TABS.filter((t) => !t.permission || hasPermission(t.permission));

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center gap-1 px-4 border-b border-neutral-200 dark:border-slate-700 bg-neutral-50 dark:bg-slate-900 overflow-x-auto flex-shrink-0">
        <span className="text-xs font-medium tracking-tight text-neutral-400 dark:text-slate-500 mr-3 whitespace-nowrap">
          Marketing Responses
        </span>
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            className={({ isActive }) =>
              `px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-all duration-150 ${
                isActive
                  ? "border-[#09244B] text-[#09244B] dark:border-blue-400 dark:text-blue-400"
                  : "border-transparent text-neutral-500 dark:text-slate-400 hover:text-neutral-900 dark:hover:text-white hover:border-neutral-300"
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto min-h-0">
        <Outlet />
      </div>
    </div>
  );
}
